import './style.scss';
import { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck} from '@fortawesome/free-solid-svg-icons';
import Utils from "../../shared/utils";
import Constants from '../../shared/constants';

const PSSplash = () => {
    
    const {t} = useTranslation('splash');

    /**
     * Get local storage
     */
     const getLocalStorage = () => {
        const isON = window.localStorage.getItem(Constants.IUCN_SPLASH_DO_NOT_SHOW_AGAIN);
        
        return !isON || isON !== 'on';
    }

    /**
     * Set local storage
     */
    const setLocalStorage = () => {
        window.localStorage.setItem(Constants.IUCN_SPLASH_DO_NOT_SHOW_AGAIN, state.doNotShowAgain ? 'on': 'off');
    }

    const [state, setState] = useState({
        visible: getLocalStorage(),
        doNotShowAgain: window.localStorage.getItem(Constants.IUCN_SPLASH_DO_NOT_SHOW_AGAIN) === 'on' ?? true
    });

    useEffect(() => {    
        //Title
        const titleSpan: HTMLSpanElement | null = document.getElementById('splashTitle');
        const watchVideo: HTMLSpanElement | null = document.getElementById('watchVideo');
        // const guideWatchVideo: HTMLSpanElement | null = document.getElementById('GuidewatchVideo')

        // if(guideWatchVideo) {
        //         guideWatchVideo.innerHTML = t('PSguideformWatchVideo');
        // }
        
        if(titleSpan) {
            titleSpan.innerHTML = t('PStitle');
        }
        
        if(watchVideo) {
            watchVideo.innerHTML = t('PSformWatchVideo');
        }
    });  

    /**
     * Close splash screen
     */
    const close = () => {
        Utils.setStateValue('visible', false, state, setState)
        setLocalStorage();
    }

    /**
     * Start
     */
     const start = () => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        close();
    }   

    return (
        state.visible ?  
        <div className="splashDiv">
            <div className="row shadow-lg p-3 mb-5 bg-white big-border-radius splashContent" style={{backgroundImage: `url("${process.env.PUBLIC_URL}/assets/background/splash-bg.svg")`}}>

                <div className="closeDiv"><span className="actionIcon closeSpan" onClick={close}>&#x2715;</span></div>                

                <div className="row bigText pageTitle">
                    <span id="splashTitle"></span> 
                </div>

                <div className="row commonText">
                    <p>{t('PSformPurpose')}</p> 
                </div>

                <div className="row commonText">
                    <p>{t('PSformShareInfos')}</p> 
                </div> 

                <div className="row infosDiv">
                {[...Array(8)].map((x, i) =>
                    <div className="row commonText" key={i}>
                        <p>
                            <span className="infoIndex">{i + 1}</span>
                            <span className="infoText">{t(`PSinfo${i + 1}`)}</span>
                        </p> 
                    </div> 
                )}
                </div>

                <div className="row commonText">
                    <FontAwesomeIcon className="checkIcon" icon={ faCheck }/>
                    <p className="floatContent">{t('PSformExit')}</p> 
                </div> 

                <div className="row commonText">
                    <FontAwesomeIcon className="checkIcon" icon={ faCheck }/>
                    <p className="floatContent">{t('PSformSubmitData')}</p> 
                </div> 

                <div className="row commonText">
                    <FontAwesomeIcon className="checkIcon" icon={ faCheck }/>
                    <p className="floatContent" id="watchVideo"></p> 
                </div>

                {/* <div className="row commonText">
                    <FontAwesomeIcon className="checkIcon" icon={ faCheck }/>
                    <p className="floatContent" id="GuidewatchVideo"></p> 
                </div> */}

                <div className="row commonText">
                    <FontAwesomeIcon className="checkIcon" icon={ faCheck }/>
                    <p className="floatContent">{t('PSfillMondatoryQuestions')}</p> 
                </div>

                <div className="row commonText actionsDiv">
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="keepSignedCbx" checked={state.doNotShowAgain} onChange={(e) => {Utils.setStateValue('doNotShowAgain', e.target.checked, state, setState)}}/>
                        <label className="form-check-label mediumText" htmlFor="keepSignedCbx">{t('PSdoNotShowAgain')}</label>
                    </div>

                    <button className="startBtn primary" onClick={start}>
                        <span>{t('PSstart')}</span> 
                    </button>
                </div>
            </div>
        </div>

        :<div></div>
    )
};

export default PSSplash